export const CONSOLE_PERMISSIONS = {
  HOME_DASHBOARD: "home_dashboard",
  VIEW_PINGS: "view_pings",
  VIEW_APPOINTMENTS: "view_appointments",
  MANAGE_APPOINTMENTS: "manage_appointments",
  VIEW_PATIENTS: "view_patients",
  VIEW_TRACKER: "view_tracker",
  VIEW_TREATMENT_OVERVIEW: "view_treatment_overview",
  CREATE_NOTES: "create_notes",
  ASSIGN_CHATS: "assign_chats",
  TRANSFER_CHATS: "transfer_chats",
  MANAGE_STAFF: "manage_staff",
  MANAGE_RBAC: "manage_rbac",
  MANAGE_COMMUNICATIONS: "manage_communications",
  VIEW_MAINTENANCE: "view_maintenance",
  MANAGE_MAINTENANCE: "manage_maintenance",
  VIEW_CONSULTATION_RECORDINGS: "view_consultation_recordings",
  VIEW_SERVICES: "view_services",
  MANAGE_SERVICES: "manage_services",
  VIEW_PROGRAM: "view_program",
  MANAGE_PROGRAM: "manage_program",
  VIEW_PROGRAM_PATIENT: "view_program_patient",
  MANAGE_PROGRAM_PATIENT: "manage_program_patient",
  VIEW_PAYMENTS: "view_payments",
  VIEW_BILLING_INVOICES: "view_billing_invoices",
  MANAGE_PROMO_CODES: "manage_promo_codes",
  MANAGE_NUTRITION_DB: "manage_nutrition_db",
  MANAGE_NUTRITION_PLANS: "manage_nutrition_plans",
  MANAGE_MEDICINE_DB: "manage_medicine_db",
  MANAGE_DISEASE_DB: "manage_disease_db",
  MANAGE_USERS: "manage_users",
} as const;

export type ConsolePermission =
  (typeof CONSOLE_PERMISSIONS)[keyof typeof CONSOLE_PERMISSIONS];

export type PermissionMatchMode = "any" | "all";

export type PermissionRequirement = {
  permissions: readonly ConsolePermission[];
  match?: PermissionMatchMode;
};

type PermissionCheckers = {
  hasPermission: (permission: string) => boolean;
  hasAnyPermission: (permissions: readonly string[]) => boolean;
};

export const meetsPermissionRequirement = (
  requirement: PermissionRequirement,
  { hasPermission, hasAnyPermission }: PermissionCheckers
) =>
  requirement.match === "all"
    ? requirement.permissions.every(hasPermission)
    : hasAnyPermission(requirement.permissions);
